import React from 'react';
import { HeaderModelData } from 'types/model';
import { userGroup } from './styles';
import { Profile } from '../profile';
import { ShoppingButton } from '../shopping-list';
import { BasketButton } from '../basket';
import { useIsCheckout } from '../../hooks/use-is-checkout';
import { ShoppingButtonNew } from '../shopping-list/shopping-list-button-new';
import { useAllowComparison } from 'common/hooks/use-allow-comparison';
import { DeviceType } from 'types';

export const USER_GROUP_QA_LOCATOR = 'header-user-group';

type ProfileGroupProps = {
  model: HeaderModelData;
  deviceType: DeviceType;
};

export const ProfileGroup = ({ model, deviceType }: ProfileGroupProps) => {
  const isCheckout = useIsCheckout();
  const isAllowComparison = useAllowComparison();
  const isDesktopDevice = deviceType === 'desktop';

  if (!isDesktopDevice) {
    return null;
  }

  return (
    <div className={userGroup} data-qa={USER_GROUP_QA_LOCATOR}>
      <Profile model={model} />
      {!isCheckout &&
        (isAllowComparison ? <ShoppingButtonNew model={model} /> : <ShoppingButton model={model} />)}
      <BasketButton />
    </div>
  );
};
